module.exports = __webpack_public_path__ + "img/YasinArif.ec2260a6.jpg";